<div class="present-task-additional-settings" #formWrapper [formGroup]="form">
	<button
		type="button"
		#validationButton
		class="present-task-additional-settings__validation-button"
		[focusOnFirstInvalidField]="{ formGroup: form, formWrapper: formWrapper }">
	</button>
	@if (shouldShowSourceMediaSetting()) {
		<source-media-setting
			[selectedTemplate]="template"
			[activity]="activity"
			[sourceMediaControl]="sourceMediaControl"
			[hasSelfSelectSourceMediaControl]="hasSelfSelectSourceMediaControl"
			[sourceTypeControl]="sourceTypeControl">
		</source-media-setting>
	}
	<h5 class="present-task-additional-settings__heading">
		{{ 'activity-preview-editor-task-settings' | translate }}
	</h5>
	@if (shouldShowCommentPrivacySetting()) {
		<div class="form-group present-task-settings-privacy-group">
			<mat-form-field appearance="outline" class="present-task-settings-privacy-select">
				<mat-label>{{ 'activity-editor-new_comment-privacy' | translate }}</mat-label>
				<mat-select [formControl]="privacyControl">
					<mat-select-trigger>
						{{ getSelectedCommentPrivacyOption()?.titleKey | translate }}
					</mat-select-trigger>
					@for (option of commentPrivacyOptions; track option.key) {
						<mat-option [value]="option.key">
							<div class="present-task-settings-privacy-option">
								<div class="present-task-settings-privacy-option-title">
									{{ option.titleKey | translate }}
								</div>
								<div class="present-task-settings-privacy-option-description">
									{{ option.descriptionKey | translate }}
								</div>
							</div>
						</mat-option>
					}
				</mat-select>
				<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
			</mat-form-field>
		</div>
	}
	@if (activity.isViewable('live_session_enabled')) {
		<div class="form-group">
			<mat-checkbox
				color="primary"
				formControlName="live_session_enabled">
				<span translate="activity-editor_allow-real-time-feedback"></span>
			</mat-checkbox>
			<button
				type="button"
				[goCdkPopover]="'activity-editor-new_live-review-help' | translate"
				class="ficon-app-help-circle-outline icon-btn"
				[attr.aria-label]="'activity-editor-new_live-review-help_aria-label' | translate">
			</button>
		</div>
	}
	@if (activity.isViewable('is_conversation')) {
		<div class="form-group">
			<mat-checkbox
				color="primary"
				formControlName="is_conversation">
				<span translate="activity-editor_allow-group-recording"></span>
			</mat-checkbox>
			<button
				type="button"
				[goCdkPopover]="'activity-editor-new_multiple-cameras-help' | translate"
				class="ficon-app-help-circle-outline icon-btn"
				[attr.aria-label]="'activity-editor-new_multiple-cameras-help_aria-label' | translate">
			</button>
		</div>
	}
	@if (activity.isViewable('time_limit')) {
		<div class="form-group time-limit-group">
			<mat-checkbox
				color="primary"
				formControlName="is_time_limit_enabled"
				>
				<span translate="{{ isTimeLimitEnabledControl.value ? 'activity-editor-header_minutes-limit' : 'activity-editor-header_time-limit' }}"></span>
			</mat-checkbox>
			@if (isTimeLimitEnabledControl.value) {
				<mat-form-field appearance="outline" class="present-task-settings__time-input">
					<input
						matInput
						type="number"
						min="1"
						formControlName="time_limit"
						data-cy="time-limit-input">
				</mat-form-field>
			}
		</div>
	}
	@if (activity.isViewable('has_single_recording_attempt')) {
		<div class="form-group">
			<mat-checkbox
				color="primary"
				data-cy="single-attempt-checkbox"
				formControlName="has_single_recording_attempt">
				<span translate="activity-editor-header_single-recording-attempt"></span>
			</mat-checkbox>
		</div>
	}
	@if (activity.isViewable('is_slides_enabled')) {
		<div class="form-group">
			<mat-checkbox
				color="primary"
				formControlName="is_slides_enabled">
				<span translate="activity-editor_allow-presenter-slides"></span>
			</mat-checkbox>
		</div>
	}
	@if (shouldShowVideoShareSetting()) {
		<div class="form-group">
			<mat-checkbox
				color="primary"
				formControlName="is_video_share_enabled">
				<span translate="activity-editor-new_video-share-label"></span>
			</mat-checkbox>
			<button
				type="button"
				[goCdkPopover]="'activity-editor-new_video-share-help' | translate"
				class="ficon-app-help-circle-outline icon-btn"
				[attr.aria-label]="'activity-editor-new_video-share-help_aria-label' | translate">
			</button>
		</div>
	}
	@if (activity.isViewable('is_video_seeking_disabled')) {
		<div class="form-group">
			<mat-checkbox
				color="primary"
				formControlName="is_video_seeking_disabled">
				<span translate="activity-editor_disable-source-video-rewind-skip"></span>
			</mat-checkbox>
		</div>
	}
	@if (activity.isViewable('is_source_media_cc_disabled')) {
		<div class="form-group">
			<mat-checkbox
				color="primary"
				formControlName="is_source_media_cc_disabled">
				<span translate="activity-editor_disable-source-video-closed-captions"></span>
			</mat-checkbox>
		</div>
	}
</div>
